import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class CtaV7 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let imagealt = "image";

    return (
      <section
        className="cta-six  go-top"
        style={{
          backgroundImage:
            "url(" +
            publicUrl +
            "assets/images/backgrounds/home-4-bubbled-bg.png)",
        }}
      >
        <img
          // src={publicUrl + "assets/images/resources/home-4-moc-4.png"}
          src="https://solverwp.com/demo/react/bizkar/assets/images/resources/home-4-moc-4.png"
          className="cta-six__moc"
          alt={imagealt}
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="cta-six__content">
                <div className="cta-six__icon">
                  <i className="fas fa-leaf-heart" />
                </div>
                {/* /.cta-six__icon */}
                <h3>
                  We Serve <br /> A Wide Range of Industries
                </h3>
                <p>
                  We specialize in serving a wide range of industries including
                  IT, Fintech, oil and gas, events, education, healthcare,
                  hospitality, logistics, and more. Our tailored digital
                  marketing solutions cater to the unique needs of each
                  industry, helping businesses stand out, reach their target
                  audience, and drive conversions. With expertise in event
                  marketing and experience across various sectors, we deliver
                  effective strategies that generate results for businesses of
                  all sizes.
                </p>
                <a href="#" className="thm-btn cta-six__btn">
                  Get Started <i className="fa fa-angle-double-right" />
                </a>
                {/* /.thm-btn cta-six__btn */}
              </div>
              {/* /.cta-six__content */}
            </div>
            {/* /.col-lg-5 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
    );
  }
}

export default CtaV7;
